/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
import React, { createContext, useContext, useState } from "react";
//custom libraries

import {
  FORM_FIELD_ORDER_DATE_FROM,
  FORM_FIELD_ORDER_DATE_TO,
} from "../constants/common";

const initParams: ParamsJson = {
  [FORM_FIELD_ORDER_DATE_FROM]: "",
  [FORM_FIELD_ORDER_DATE_TO]: "",
};

interface ParamsJson {
  [FORM_FIELD_ORDER_DATE_FROM]?: string;
  [FORM_FIELD_ORDER_DATE_TO]?: string;
}

export const ClientSearchParamsContext: React.Context<any> =
  createContext(null);

export const ClientSearchParamsDataProvider = ({ children }: any) => {
  const [params, setParams] = useState<ParamsJson | any>(initParams);

  return (
    <ClientSearchParamsContext.Provider
      value={{
        params,
        setParams,
      }}>
      {children}
    </ClientSearchParamsContext.Provider>
  );
};

export const useClientsReportParamsData = () =>
  useContext(ClientSearchParamsContext);
